/* unplugin-vue-components disabled */import { render } from "./Header.vue?vue&type=template&id=134a4b50&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=134a4b50&scoped=true&lang=scss"
import "./Header.vue?vue&type=style&index=1&id=134a4b50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134a4b50"]])

export default __exports__